export default class NotificationType {
    static get FiscalCheckPrintFailed () { return 1 }
    static get WorkShiftNotClosed () { return 2 }
    static get PrintCheckFailed () { return 3 }
    static get OrderCanceled () { return 4 }
    // FAKT Support (setsushi-back CRMNotificationType): адресат - филиал, прочитанность на сервере.
    // 5 занят TerminalResultNotApplied в ветке 2.6.0.
    static get SupportReplied () { return 6 }
    static get SupportTakenInWork () { return 7 }
    static get SupportSolvedRate () { return 8 }
    static get SupportClosedNoReply () { return 9 }
    // Оператор поддержки завёл тикет на филиал из деска (2026-10-14).
    static get SupportCreated () { return 10 }

    static isSupport (type) {
        return type >= NotificationType.SupportReplied && type <= NotificationType.SupportCreated
    }
}
